/// <reference path="../include.ts" />

namespace project_guide {

	import Scene = scn.Scene;
	import DataParser = project_common.DataParser;
	import Application = project_common.Application;

	export class RegionScene extends Scene {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(regionId:string) {
			super(regionId);
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implOnLoad():cmd.Command {
			return new cmd.Func(():void => {
				trace('[RegionScene ' + this.getName() + '] load');

				// set current context
				const message = <SceneTransferMessage>this.getTransferInfo().message;
				const currentState = message.currentState;
				const spot = Application.getSpotData();

				currentState.currentRegion = DataParser.getRegionFromSpot(spot, this.getName());
			});
		}

		protected implOnUnload():cmd.Command {
			return new cmd.Func(():void => {
				trace('[RegionScene ' + this.getName() + '] unload');

				// clear current context
				const message = <SceneTransferMessage>this.getTransferInfo().message;
				const currentState = message.currentState;

				currentState.currentRegion = null;

				// remove self from scene tree
				this.getParent().removeChild(this);
			});
		}

		protected implOnArrive():cmd.Command {
			return new cmd.Func(():void => {
				trace('[RegionScene ' + this.getName() + '] arrive');

				const message = <SceneTransferMessage>this.getTransferInfo().message;
				const currentState = message.currentState;

				// set scroll
				if (message.scroll) {
					const listView = ListView.getInstance();
					listView.scrollToRegion(currentState.currentRegion, message.smoothScroll);
				}
			});
		}

		protected implOnLeave():cmd.Command {
			return new cmd.Func(():void => {
				trace('[RegionScene ' + this.getName() + '] leave');
			});
		}

		protected implOnAscend():cmd.Command {
			return new cmd.Func(():void => {
				trace('[RegionScene ' + this.getName() + '] ascend');
			});
		}

		protected implOnDescend():cmd.Command {
			return new cmd.Func(():void => {
				trace('[RegionScene ' + this.getName() + '] descend');
			});
		}





		// --------------------------------------------------
		//
		// MEMBER
		//
		// --------------------------------------------------
	}
}
